import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {Outlet} from 'react-router-dom';

function BlankLayout(): JSX.Element {
    return (
        <div className="l-base is-collapsed">
            <main>
                <Outlet />
            </main>
        </div>
    );
}

export default BlankLayout;
